import React, { memo, useMemo } from 'react';
import { Box, Typography } from '@mui/material';
import { useSelector } from 'react-redux';
import { CommonData } from '@alycecom/modules';

import { IShippingAddress } from '../../store/shipping/shipping.types';
import { getCountryById } from '../../../../store/countries/countries.selectors';

export interface IOriginalAddressProps {
  address: IShippingAddress;
}

const OriginalAddress = ({ address }: IOriginalAddressProps): JSX.Element => {
  const { address2, city, country: countryId, state: stateName, address: street, zipcode } = address;
  const addressInfo = address2 ? `${street}, ${address2}` : street;

  const country = useSelector(useMemo(() => getCountryById(countryId || CommonData.COUNTRIES.US.id), [countryId]));
  const state = useMemo(() => country?.states?.find(item => item.name === stateName), [country, stateName]);

  return (
    <Box>
      <Typography className="Body-Regular-Left-Static">{addressInfo}</Typography>
      <Typography className="Body-Regular-Left-Static">
        {city}, {state?.abbreviation ?? stateName} {zipcode}
      </Typography>
      <Typography className="Body-Regular-Left-Static">{country?.name}</Typography>
    </Box>
  );
};

export default memo<IOriginalAddressProps>(OriginalAddress);
